
import React, { useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import InitialSetup from "@/components/setup/InitialSetup";
import { useInvestorProcessing } from "@/hooks/useInvestorProcessing";
import APIKeyDebug from "@/components/debug/APIKeyDebug";
import { migrateAPIKeys } from "@/utils/ai/apiKeyMigration";

const UploadData = () => {
  const { 
    handleFileData, 
    handleReprocess,
    loadSavedData
  } = useInvestorProcessing();
  
  // Load any existing data and migrate API keys when component mounts
  useEffect(() => {
    loadSavedData();
    // Migrate any existing API keys to the correct format
    migrateAPIKeys();
  }, []);

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Upload Data</h1>
      
      <Card className="mb-8">
        <CardHeader>
          <CardTitle>Get Started</CardTitle>
          <CardDescription>
            Upload your Excel file with investor data and contacts to begin. 
            You can merge with existing data to preserve enriched information.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            <InitialSetup 
              onFileData={handleFileData}
              onReprocess={handleReprocess}
              onProviderUpdated={() => {
                // Trigger a re-render to update API key status
                window.location.reload();
              }}
            />
          </div>
        </CardContent>
      </Card>
      
      {/* Add API key debug panel */}
      <APIKeyDebug />
    </div>
  );
};

export default UploadData;
